module.exports = __webpack_public_path__ + "vue-assets/img/payments-espago.33f0774b.png";